import { IoHomeOutline,   IoBarChartOutline, IoSettingsOutline } from "react-icons/io5";
import { FaShoppingCart } from "react-icons/fa";
import { MdOutlineShoppingCart } from "react-icons/md";
import { PiSuitcaseSimpleLight } from "react-icons/pi";


export const allUnits = [
  { name: 'Head Office', FormID: '1018' ,UnitId:'684fee05f58e7b161f931f30'},
  { name: 'Unit 1', FormID: '1019' ,UnitId:'685f739230fe1a916881a428' },
  // { name: 'Unit 2', FormID: '1020' },
  // { name: 'Unit 3', FormID: '1021' },
];

const currentUnit = localStorage.getItem('unitName')

export const sidebarMenu = [
  {
    title: 'Dashboard',
    FormID:1000,
    icon: <IoHomeOutline />,
    roles: ['admin', 'employee'],
     UnitAccess: ['Head Office','Unit 1'],
  },
  {
    title: 'Stocks',
    icon:<FaShoppingCart />,
    children: [
     { title: 'Stock List' ,FormID:'1008',roles: ['admin', 'employee'],UnitAccess: ['Head Office','Unit 1'],},
     { title: 'Internal Sharing' ,FormID:'1010',roles: ['admin', 'employee'],UnitAccess: ['Head Office','Unit 1'],},
     { title: 'Inwards History' ,FormID:'1016',roles: ['admin', 'employee'],UnitAccess: ['Head Office','Unit 1'],},      
     { title: 'Outwards History' ,FormID:'1015',roles: ['admin', 'employee'],UnitAccess: ['Head Office','Unit 1'],},      
    ],
    roles: ['admin', 'employee'],
    UnitAccess: ['Head Office','Unit 1'],
  },
  {
    title: 'Order Management',
    icon: <MdOutlineShoppingCart />,
    children: [
     { title: 'Order Creation' ,FormID:'1013',roles: ['admin', 'employee'],UnitAccess: ['Head Office','Unit 1'],},
     { title: 'Order Details' ,FormID:'1014',roles: ['admin', 'employee'],UnitAccess: ['Head Office','Unit 1'],},
    ],
    roles: ['admin', 'employee'],
    UnitAccess: ['Head Office','Unit 1'],
  },
  {
    title: 'Master forms',
    icon: <PiSuitcaseSimpleLight />,
    children: [
       { title: 'Unit' ,FormID:'1001',roles: ['admin'],UnitAccess: ['Head Office'],},
       { title: 'Department' ,FormID:'1002',roles: ['admin'],UnitAccess: ['Head Office'],},
       { title: 'Employee' ,FormID:'1003',roles: ['admin'],UnitAccess: ['Head Office'],},
      //  { title: 'Brand' ,FormID:'1004',roles: ['admin'],UnitAccess: ['Head Office','Unit 1'],},
      //  { title: 'Category' ,FormID:'1005',roles: ['admin'],UnitAccess: ['Head Office','Unit 1'],},
      //  { title: 'Child Product' ,FormID:'1006',roles: ['admin'],UnitAccess: ['Head Office','Unit 1'],},
       { title: 'Parent Product' ,FormID:'1007',roles: ['admin'],UnitAccess: ['Head Office','Unit 1'],},
       { title: 'Main Parent' ,FormID:'1009',roles: ['admin'],UnitAccess: ['Head Office','Unit 1'],},
       { title: 'Customer' ,FormID:'1011',roles: ['admin'],UnitAccess: ['Head Office'],},
       { title: 'Product Type' ,FormID:'1012',roles: ['admin'],UnitAccess: ['Head Office','Unit 1'],},
      //  { title: 'Add Stock' ,FormID:'1009',roles: ['admin'],UnitAccess: ['Head Office','Unit 1'],},
    ],
    roles: ['admin'],
    UnitAccess: ['Head Office','Unit 1'],
  },
   {title: 'Log view',
    icon: <MdOutlineShoppingCart />,
    children: [
     { title: 'Logs' ,FormID:'1017',roles: ['admin'],UnitAccess: ['Head Office','Unit 1'],},
    ],
    roles: ['admin'],
    UnitAccess: ['Head Office','Unit 1'],
  },
     {title: 'Other Units',
    icon: <MdOutlineShoppingCart />,
    children: [{ title: 'Head Office' ,FormID:'1018',roles: ['admin'],UnitAccess: ['Head Office','Unit 1'],},
  { title: 'Unit 1' ,FormID:'1019',roles: ['admin'],UnitAccess: ['Head Office','Unit 1'],}
  ],
    roles: ['admin'],
   UnitAccess: ['Head Office', 'Unit 1', 'Unit 2', 'Unit 3'],
  },
  {title: 'Admin Panel',
    icon: <MdOutlineShoppingCart />,
    children: [{ title: 'Menu Registry' ,FormID:'1022',roles: ['admin'],UnitAccess: ['Head Office','Unit 1'],},
  { title: 'User Rights' ,FormID:'1023',roles: ['admin'],UnitAccess: ['Head Office','Unit 1'],}
  ],
    roles: ['admin'],
   UnitAccess: ['Head Office', 'Unit 1', 'Unit 2', 'Unit 3'],
  },
];

export const generateOtherUnitsMenu = (currentUnitName, allUnits) => {
  return allUnits
    .filter(unit => unit.name !== currentUnitName)
    .map(unit => ({
      title: unit.name,
      FormID: unit.FormID,
      roles: ['admin'],
      UnitAccess: [currentUnitName],
      UnitId:unit.UnitId
    }));
};

export const prepareSidebarMenu = (sidebarMenu, currentUnitName) => {
  const otherUnitsChildren = generateOtherUnitsMenu(currentUnitName, allUnits);

  return sidebarMenu.map(item => {
    if (item.title === 'Other Units') {
      return {
        ...item,
        children: otherUnitsChildren,
      };
    }
    return item;
  });
};

export const updatedMenu = prepareSidebarMenu(sidebarMenu, currentUnit);

export const filterMenuByRoleAndUnit = (menu, role, unit) => {
  return menu
    .filter(item => {
      const hasRole = item.roles?.includes(role);
      const hasUnit = item.UnitAccess?.includes(unit);
      return hasRole && hasUnit;
    })
    .map(item => {
      if (item.children) {
        const filteredChildren = item.children.filter(child => {
          const hasRole = child.roles?.includes(role);
          const hasUnit = child.UnitAccess?.includes(unit);
          return hasRole && hasUnit;
        });
        return { ...item, children: filteredChildren };
      }
      return item;
    })
    .filter(item => {
      // remove parent menus that have no children left after filtering
      if (item.children) {
        return item.children.length > 0;
      }
      return true;
    });
};


